import { ref } from '@nuxtjs/composition-api';
import {
  PartsDbVehicleSummary,
  useRegoSearch,
} from '@unified-commerce/gpc-vue-storefront-parts-db';

const useVehiclesByRego = () => {
  const vehicles = ref<PartsDbVehicleSummary[]>([]);
  const error = ref('');

  const { result, loading, getVehiclesByRego, error: regoSearchError } = useRegoSearch();

  const reset = () => {
    error.value = '';
    vehicles.value = [];
  };

  const fetchVehicles = async (rego: string, state: string) => {
    error.value = '';
    await getVehiclesByRego({ rego, state });

    if (result.value) {
      vehicles.value = result.value;
    }

    if (regoSearchError.value) {
      error.value = 'There is an issue getting your rego number.';
    } else if (!vehicles.value.length) {
      error.value = 'Bike not found! Please enter correct rego number and state combination.';
    }
  };

  return {
    reset,
    vehicles,
    loading,
    fetchVehicles,
    error,
  };
};

export default useVehiclesByRego;
